/**
 * A price as the customer sees it while ordering: "₹3,999/-" (Indian digit
 * grouping, paise only when present). Credits are shown the same way — 1
 * credit = ₹1 — so order screens never say "credits".
 */
export function formatRupees(value) {
  const n = Number(value) || 0;
  return `₹${n.toLocaleString("en-IN", { maximumFractionDigits: 2 })}/-`;
}
